var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("При возникновении ошибок и вопросов обращайтесь на "),_c('a',{attrs:{"href":"mailto:help@crmcalls.ru"}},[_vm._v("help@crmcalls.ru")])])
}]

export { render, staticRenderFns }